import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get values() {
    return {
      enabled: { type: Boolean, default: true },
      // closeOnClickOutsideValue: should be use with data-bs-trigger="click"
      closeOnClickOutside: { type: Boolean, default: false },
    }
  }

  connect() {
    this.tooltip = new bootstrap.Tooltip(this.element)

    if (!this.enabledValue) {
      this.disable()
    }

    if (this.closeOnClickOutsideValue) {
      this.handleClickOutside = this.handleClickOutside.bind(this)

      this.element.addEventListener("shown.bs.tooltip", () => {
        setTimeout(() => {
          document.addEventListener("click", this.handleClickOutside)
        }, 0)
      })

      this.element.addEventListener("hidden.bs.tooltip", () => {
        document.removeEventListener("click", this.handleClickOutside)
      })
    }
  }

  disconnect() {
    this.tooltip?.hide()

    if (this.closeOnClickOutsideValue) {
      document.removeEventListener("click", this.handleClickOutside)
    }
  }

  handleClickOutside(event) {
    if (this.element.contains(event.target)) {
      return
    }

    const tooltipElement = document.querySelector(".tooltip.show")
    if (tooltipElement && tooltipElement.contains(event.target)) {
      return
    }

    this.tooltip?.hide()
  }

  enable() {
    this.enabledValue = true
    this.tooltip?.enable()
  }

  disable() {
    this.enabledValue = false
    this.tooltip?.disable()
  }
}
